import React, { FunctionComponent, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { getActiveFilters, getCustomFacets, getFilterQueries, getTextQuery } from 'browse3/store/UrlSlice';
import './FeaturedContentBanner.scss';
import { ForgeBanner, ForgeButton } from '@tylertech/forge-react';
import {
  encodeFeaturedContentPath,
  translateCeteraQueryParamToUrlParam,
  translateDisplayTypeFromCeteraToUrlFormat,
} from 'browse3/helpers';
import { assign, origin } from 'common/window_location';
import { I18n } from 'common/i18n';

const FeaturedContentBanner: FunctionComponent = () => {
  const PARAMS_ALLOWLIST = ['category', 'limitTo', 'provenance', 'federation_filter'];
  const t = (k: string) => I18n.t(k, { scope: 'controls.browse.browse3.featured_content.banner' });
  const customFacets = useSelector(getCustomFacets);
  const searchFilter = useSelector(getTextQuery);
  const activeFilters = useSelector(getActiveFilters);

  if (searchFilter) {
    return <></>;
  }

  const navigateToCatalogLandingPage = () => {
    let queryParams = '';

    if (activeFilters) {
      for (const filter of activeFilters) {
        const translatedParam = translateCeteraQueryParamToUrlParam(filter.queryParam);

        if (
          PARAMS_ALLOWLIST.includes(translatedParam) ||
          customFacets
            .map((facet) => {
              return facet.param;
            })
            .includes(translatedParam)
        ) {
          if (queryParams.length > 0) {
            queryParams += '&';
          }
          if (translatedParam === 'limitTo') {
            queryParams += `limitTo=${translateDisplayTypeFromCeteraToUrlFormat(filter.paramValue)}`;
          } else {
            const paramValue = encodeFeaturedContentPath(filter.paramValue);
            queryParams += `${translatedParam}=${paramValue}`;
          }
        }
      }
    }

    if (!queryParams) {
      queryParams = 'custom_path=%2Fbrowse';
    }

    assign(origin() + '/catalog_landing_page/manage?' + queryParams.replace(/ /g, '+'));
  };

  const showManageBannerUsingActiveFilters = () => {
    const isFiltersNull = activeFilters === null;
    const numFilters = activeFilters?.length;
    return isFiltersNull || numFilters < 2;
  };

  const banner: ReactElement = showManageBannerUsingActiveFilters() ? (
    <ForgeBanner canDismiss={false} className="featured-content-banner forge-typography--body1">
      <div>{t('label')}</div>
      <ForgeButton
        slot="button"
        variant="outlined"
        data-testid="featured-content-banner-button"
        onClick={navigateToCatalogLandingPage}
      >
        {t('button')}
      </ForgeButton>
    </ForgeBanner>
  ) : (
    <></>
  );

  return <>{banner}</>;
};

export default FeaturedContentBanner;
